/**
 * Header's top menu item
 */
import React, { useRef, useEffect } from 'react';
import classnames from 'classnames';
import MediaQuery from 'react-responsive';
import { Link } from '@latitude/link';
import Section from '@latitude/section';
import { Chevron } from '@latitude/chevron';
import './_top-menu-item.scss'; // A cutoff point (in pixels to switch to desktop layout)

var DESKTOP_CUTOFF_POINT = 992;

var TopMenuItem = function TopMenuItem(props) {
  var className = props.className,
      id = props.id,
      label = props.label,
      trackId = props.trackId,
      href = props.href;
  var menuItemRef = useRef(null);
  /*
   * Append class to menu item when matching location path
   */

  useEffect(function () {
    if ("" + href === location.pathname) {
      return menuItemRef.current.classList.add('is-active');
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    key: id,
    ref: menuItemRef,
    className: classnames('top-menu-item', className)
  }, /*#__PURE__*/React.createElement(Link, {
    className: "top-menu-item__button link--no-style trackcustomanalytics",
    "data-trackid": trackId,
    href: href,
    noStyle: true,
    trackEventData: {
      label: label
    }
  }, label && /*#__PURE__*/React.createElement("p", {
    className: "top-menu-item__label"
  }, label), /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: DESKTOP_CUTOFF_POINT - 1
  }, /*#__PURE__*/React.createElement(Chevron, {
    className: "top-menu-item__chevron",
    color: "#9a9a9a",
    direction: "right"
  }))));
};

export default TopMenuItem;